import React from 'react';
import { ReactComponent } from 'Common/components/Icons/safety-harness.svg';

const SafetyHarness = () => <ReactComponent className="MuiSvgIcon-root" />;

export default SafetyHarness;
